export default __webpack_public_path__ + "static/service-3-385785c2f282e7f828b1032d44543ece.jpg";